export default function Kevin() {
	return (
		<div className="bio">
			<h3>Kevin Xu</h3>
			<p>Kotlin Bunny</p>
		</div>
	);
}